import axios from 'axios'

import GeocodeInterface from '@/model/interfaces/geocode'

const GEOCODE_API_URL = 'https://api.bigdatacloud.net/data/reverse-geocode-client'

export const getReverseGeocode = async (
  latitude: number,
  longitude: number,
  locale: string
): Promise<GeocodeInterface> => {
  const url = `${GEOCODE_API_URL}?latitude=${latitude}&longitude=${longitude}&localityLanguage=${locale}`
  const { data: resData } = await axios.get(url)
  return resData
}
